import {StarFilled} from '@ant-design/icons';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TestimonialSection = ({data}) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className={'w-full flex justify-center items-center lg:px-20 p-4'} data-aos={'fade-up'}>
      <div className={'bg-gray-100 py-1 w-full'}>
        <div className={'flex flex-col justify-center items-center px-4'}>
          <h2 className={'prata-regular text-primary-900 lg:text-3xl text-xl'} data-aos={'fade-up'}>
            {data.title}
          </h2>
          <Slider {...settings} className={'w-full max-w-[1200px] mx-auto px-4 lg:px-0'}>
            {data.testimonials.map(testimonial => (
              <div key={testimonial.id} className={'p-4 flex h-full'}>
                <div className={'bg-primary-300/10 rounded-lg shadow-md p-4 flex flex-col flex-grow h-full justify-between min-h-[200px]'}>
                  <p className={'lg:text-lg font-semibold text-primary-900 text-center font-serif mb-2'}>
                    {testimonial.name}
                  </p>
                  <div className={'flex justify-center mb-4'}>
                    {Array(testimonial.rating)
                      .fill(0)
                      .map((_, i) => (
                        <StarFilled key={i} className={'text-[#FFD700] text-xl'} />
                      ))}
                  </div>
                  <p className={'text-sm text-center mb-4 flex-grow'}>{testimonial.text}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

TestimonialSection.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    testimonials: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        rating: PropTypes.number.isRequired,
        text: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default TestimonialSection;
